import styled from '@emotion/styled';

export const OrderMenuContainer = styled.div`
    .orders-menu {
        cursor: pointer;
        display: flex;
        align-items: center;
    }
`;
